export default "__VITE_ASSET__b84d8c57__"